<template>
  <div class="calico-deep-search-banner-page">
    <h2>Deep Search Banner</h2>
    <div style="width: 500px;">
      <DeepSearcBanner />
    </div>
  </div>
</template>
  
  <script>
  import DeepSearcBanner from "@/components/pattern/deepSearchBanner";
  
  export default {
    name: "CalicoDeepSearchBannerPage",
    components: {
      DeepSearcBanner,
    },
    data() {
      return {
      };
    },
  };
  </script>
  
  <style scoped lang="scss">
  .calico-deep-search-banner-page {
    padding: $space-large
  }
  </style>